var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "#525252",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.75 14C7.75 14.1989 7.67098 14.3897 7.53033 14.5303C7.38968 14.671 7.19891 14.75 7 14.75H3C2.80109 14.75 2.61032 14.671 2.46967 14.5303C2.32902 14.3897 2.25 14.1989 2.25 14V3C2.25 2.80109 2.32902 2.61032 2.46967 2.46967C2.61032 2.32902 2.80109 2.25 3 2.25H7C7.19891 2.25 7.38968 2.32902 7.53033 2.46967C7.67098 2.61032 7.75 2.80109 7.75 3C7.75 3.19891 7.67098 3.38968 7.53033 3.53033C7.38968 3.67098 7.19891 3.75 7 3.75H3.75V13.25H7C7.19891 13.25 7.38968 13.329 7.53033 13.4697C7.67098 13.6103 7.75 13.8011 7.75 14ZM14.5306 7.96938L12.0306 5.46938C11.8897 5.32848 11.6986 5.24932 11.4994 5.24932C11.3001 5.24932 11.109 5.32848 10.9681 5.46938C10.8272 5.61027 10.7481 5.80137 10.7481 6.00063C10.7481 6.19988 10.8272 6.39098 10.9681 6.53188L12.1875 7.75H7C6.80109 7.75 6.61032 7.82902 6.46967 7.96967C6.32902 8.11032 6.25 8.30109 6.25 8.5C6.25 8.69891 6.32902 8.88968 6.46967 9.03033C6.61032 9.17098 6.80109 9.25 7 9.25H12.1875L10.9675 10.4694C10.8266 10.6103 10.7474 10.8014 10.7474 11.0006C10.7474 11.1999 10.8266 11.391 10.9675 11.5319C11.1084 11.6728 11.2995 11.7519 11.4987 11.7519C11.698 11.7519 11.8891 11.6728 12.03 11.5319L14.53 9.03187C14.6 8.96224 14.6555 8.87948 14.6934 8.78833C14.7313 8.69719 14.7508 8.59946 14.7509 8.50075C14.751 8.40204 14.7315 8.30429 14.6937 8.21311C14.6559 8.12192 14.6005 8.03909 14.5306 7.96938Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bb7a80bce7aa978f1e0d9c9069d818cc.svg";
export { ForwardRef as ReactComponent };